import Navbar from "@/components/marketing/Navbar.jsx";
import Footer from "@/components/marketing/Footer.jsx";
import { Mic, Wand2, Globe2, ShieldCheck, BookOpen, Zap, Sparkles, FileText } from "lucide-react";

const features = [
  { icon: Mic, title: "Real voice transcription", body: "Browser-based recorder + OpenAI Whisper for accurate, fast transcription." },
  { icon: Globe2, title: "4 languages, 1 mic", body: "English, Hindi, Telugu and code-switched Mixed/Hinglish are all first-class." },
  { icon: Wand2, title: "7 output modes", body: "Clean text, Email, WhatsApp, AI Prompt, Client Brief, Blog Outline, Meeting Notes." },
  { icon: Sparkles, title: "AI Polish", body: "Removes filler, fixes grammar, keeps your voice. Powered by GPT-5.4." },
  { icon: Zap, title: "One-tap transforms", body: "Polish, Professional, Shorten, Expand, Translate, Convert-to-Prompt." },
  { icon: BookOpen, title: "Personal dictionary", body: "Names, brands, technical & cultural terms stay spelled exactly the way you want." },
  { icon: FileText, title: "Snippets & shortcuts", body: "Reusable phrases, signatures and openers for instant copy-paste." },
  { icon: ShieldCheck, title: "Private by default", body: "Audio is used for transcription only. You control your history at any time." },
];

export default function Features() {
  return (
    <div className="min-h-screen bg-brand-bg">
      <Navbar />
      <section className="pt-16 pb-24 bg-mesh">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 text-center">
          <div className="text-xs uppercase tracking-widest font-semibold text-brand-purple">Features</div>
          <h1 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight text-brand-navy">Everything you need<br />to write with your voice.</h1>
          <p className="mt-5 text-brand-muted max-w-2xl mx-auto">Built voice-first. Built for India. Built to ship.</p>
        </div>
      </section>
      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((f, i) => (
            <div key={i} className="bg-white rounded-2xl border border-brand-borderc p-6 hover:shadow-soft transition">
              <div className="w-11 h-11 rounded-xl bg-gradient-primary flex items-center justify-center text-white"><f.icon className="w-5 h-5" /></div>
              <h3 className="mt-4 text-lg font-semibold text-brand-navy">{f.title}</h3>
              <p className="mt-1.5 text-sm text-brand-muted">{f.body}</p>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
